<template>
  <div
    :class="classObject"
    :style="{width: width }"
    class="FormItemWrapper"
  >
    <div class="FormItemWrapper__container">
      <div class="FormItemWrapper__label">
        <slot name="label"/>
      </div>

      <div class="FormItemWrapper__tooltip">
        <slot name="tooltip"/>
      </div>
    </div>

    <div class="FormItemWrapper__container">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormItemWrapper',
  props: {
    size: {
      type: String,
      default: 'default',
      validator: value =>
        // The value must match one of these strings
        ['default', 'xs', 'sm'].indexOf(value) !== -1
      ,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    minimal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '',
    },
  },
  computed: {
    classObject() {
      return {
        'FormItemWrapper--xs': this.size === 'xs',
        'FormItemWrapper--sm': this.size === 'sm',
        'FormItemWrapper--borderless': this.borderless,
        'FormItemWrapper--minimal': this.minimal,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.FormItemWrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}
.FormItemWrapper__container {
  display: flex;

  &:first-child {
    align-items: center;
  }
  &:nth-child(2) {
    flex-direction: column;
  }
}
.FormItemWrapper__tooltip {
  margin-left: auto;

  /deep/ .Tooltip {
    font-size: 12px;
  }
}
// Style form items
.FormItemWrapper /deep/ {
  // Select
  .el-select {
    display: block;
  }
  // Checkbox
  .el-checkbox-group {
    .el-checkbox + .el-checkbox {
      margin: 0;
    }
    .el-checkbox {
      margin-right: 30px;
    }
    .el-checkbox:last-child {
      margin: 0;
    }
  }
  // Radio button
  .el-radio-group {
    .el-radio {
      margin-left: 0;
    }
    .el-radio:first-child,
    .el-radio + .el-radio {
      margin-right: 30px;
    }
    .el-radio:last-child {
      margin-right: 0;
    }
  }
}
.FormItemWrapper.winter {
  /deep/ .FormItemLabel p,
  .Tooltip {
    color: #659ed4;
  }
}
.FormItemWrapper.summer {
  /deep/ .FormItemLabel p,
  .Tooltip {
    color: #ef5350;
  }
}
// Form item sizes
.FormItemWrapper--xs /deep/ {
  .el-input__inner {
    padding-left: 4px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  .el-input__suffix .el-select__caret {
    line-height: 30px;
  }
}
.FormItemWrapper--sm /deep/ {
  .el-input__inner {
    padding-left: 5px;
    height: 35px;
    line-height: 35px;
    font-size: 13px;
  }
  .el-input__suffix .el-select__caret {
    line-height: 35px;
  }
}
.FormItemWrapper--borderless /deep/ {
  .el-input__inner {
    border: 0;
  }
}
.FormItemWrapper--minimal /deep/ {
  .el-input__inner {
    border: 0;
    background: transparent;
    padding-left: 0;
  }
}
</style>
